import { tokens } from '@equinor/eds-tokens';

var borderRadius = tokens.shape.corners.borderRadius;
var group = {
  border: {
    type: 'border',
    radius: borderRadius
  }
};

export { group };
